<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <TabMenu :menuIndex="menuIndex" :menu="menu" />

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: [
    // 'idx',
    'status',
  ],
  data() {
    return {
      breadcrumb: [
        { name: "车辆管理" },
        { name: "车辆列表" },
      ],
      menuIndex: '',
      menu: [],
      list: ['在用', '停用', '报废'],
    };
  },
  computed: {
    ...mapState([
      'store'
    ]),
  },
  methods: {
  },
  // watch: {
  //   $route(to, from) {
  //     // console.log(from, to)
  //     if (to.params.idx !== from.params.idx) {
  //       this.menu = []
  //       this.list.map((v, i) => {
  //         const o = {
  //           name: v,
  //           // path: `/vehicle/manage/table/${to.params.idx}/list/${i + 1}`,
  //           path: `/vehicle/manage/table/${i + 1}`,
  //         }
  //         this.menu.push(o)
  //       })
  //     }
  //     this.$nextTick(() => {
  //       // console.log(this.menuIndex)
  //       this.menuIndex = this.$route.path
  //       // console.log(this.menuIndex)
  //       // console.log(this.menu)
  //     })
  //   },
  // },
  mounted() {
    this.list.map((v, i) => {
      const o = {
        name: v,
        // path: `/vehicle/manage/table/${this.idx}/list/${i + 1}`,
        path: `/vehicle/manage/table/${i + 1}`,
      }
      this.menu.push(o)
    })
    this.menuIndex = this.$route.path
    // console.log(this.menuIndex)
    // console.log(this.menu)
  },
};
</script>
